import { useEffect } from "react";
import styles from "./AlertBox.module.css";
import { t } from "i18next";

interface IModalProps {
  isOpen: any;
  setIsOpen:any;
}
// const replaceFieldNames = (message: string): string => {
//   const fieldNamesMap: { [key: string]: string } = {
//     "documentPaperAt": t('notification_from_eaes.document_date_label'),
//   };
//   for (const englishName in fieldNamesMap) {
//     if (message.includes(englishName)) {
//       message = message.replace(englishName, fieldNamesMap[englishName]);
//     }
//   }

//   return message;
// };


const AlertBox: React.FC<IModalProps> = ({ 
isOpen,
setIsOpen
}) => {
    useEffect(() => {
        const timer = setTimeout(() => {
          setIsOpen(null);
        }, 3500); 
        return () => clearTimeout(timer); 
      }, [isOpen])

    if (!isOpen) {
      return null; 
    }
    const displayMessage = isOpen.message;
    return (
        <div className={styles.modal}>
          <div className={styles.window}>
            <div className={styles.components}>
              <img
                src={isOpen.status === 'SUCCESS' ? "/icons/success.svg" : "/icons/warning.svg"} 
                className={styles.icon}
              />
               <span>{displayMessage}</span>
            </div>
          </div>
        </div>
      );     
};

export default AlertBox;
